export default __webpack_public_path__ + "static/media/switch.6f798c5d.svg";